<template>
  <a-card :bordered='false'>
    <div class='m-b-30 s_bf4f p-15'>
      <span class="fz-16 s_font_b m-r-20">实时概况</span>
      <span class='fz-16 s_c999'>更新时间：{{homeData.time}}</span>
    </div>
    <a-card class="width25 m-b-30" style=" cursor: pointer;" @click="$router.push('/antiFleeingGoods/marketAudit/warning')">
      <p>窜货二维码总数
        <a-tooltip placement='right'>
          <template #title>
            <p>统计全部窜货二维码的数量</p>
          </template>
          <InfoCircleOutlined class="fz-18 s_c376" />
        </a-tooltip>
      </p>
      <p class="fz-30 s_font_b">{{homeData.fleeing_product_qr_code_num || 0}}</p>
    </a-card>
    <div class='m-b-30 s_bf4f p-15'>
      <span class="fz-16 s_font_b m-r-20">今日概况</span>
    </div>
    <a-card class="width80 m-b-30" :bodyStyle="{padding:0}">
      <div class="s_flex_ali">
        <div class="width20 s_cfff height-120 fz-16 s_flex_center" style="background-color: #05486A;">总部数据</div>
        <div class="width25 s_flex_center">
          <div>
            <p>入库商品数量
              <a-tooltip placement='right'>
                <template #title>
                  <p>统计当天入库的小标数量</p>
                </template>
                <InfoCircleOutlined class="fz-18 s_c376" />
              </a-tooltip>
            </p>
            <p class="fz-30 s_font_b">{{homeData.general_warehousing_product_num || 0}}</p>
          </div>
        </div>
        <div class="width25 s_flex_center" >
          <div>
            <p>出库商品数量
              <a-tooltip placement='right'>
                <template #title>
                  <p>统计当天成功出库的小标数量，出库时间是今天且订单状态是已出库的订单中包含的总小标数</p>
                </template>
                <InfoCircleOutlined class="fz-18 s_c376" />
              </a-tooltip>
            </p>
            <p class="fz-30 s_font_b">{{homeData.general_out_warehousing_product_num || 0}}</p>
          </div>
        </div>
      </div>
    </a-card>
    <a-card class="width80 m-b-30" :bodyStyle="{padding:0}">
      <div class="s_flex_ali">
        <div class="width20 s_cfff height-120 fz-16 s_flex_center" style="background-color: #52C41A;">经销商数据</div>
        <div class="width25 s_flex_center">
          <div>
            <p>签收商品数量
              <a-tooltip placement='right'>
                <template #title>
                  <p>统计当天出货单收货人是经销商，且签收时间是今天的订单中包含的总小标数</p>
                </template>
                <InfoCircleOutlined class="fz-18 s_c376" />
              </a-tooltip>
            </p>
            <p class="fz-30 s_font_b">{{homeData.dealer_sign_for_product_num || 0}}</p>
          </div>
        </div>
        <div class="width25 s_flex_center">
          <div>
            <p>出库商品数量
              <a-tooltip placement='right'>
                <template #title>
                  <p>统计当天全部经销商成功出库的小标数量，经销商生成的订单出库时间是今天且订单状态是已出库的订单中包含的总小标数</p>
                </template>
                <InfoCircleOutlined class="fz-18 s_c376" />
              </a-tooltip>
            </p>
            <p class="fz-30 s_font_b">{{homeData.dealer_out_warehousing_product_num || 0}}</p>
          </div>
        </div>
        <div class="width25 s_flex_center">
          <div>
            <p>退货商品数量
              <a-tooltip placement='right'>
                <template #title>
                  <p>统计当天退货人是经销商的退货单中包含的总小标数</p>
                </template>
                <InfoCircleOutlined class="fz-18 s_c376" />
              </a-tooltip>
            </p>
            <p class="fz-30 s_font_b">{{homeData.dealer_refund_warehousing_product_num || 0}}</p>
          </div>
        </div>
      </div>
    </a-card>
    <a-card class="width80 m-b-30" :bodyStyle="{padding:0}">
      <div class="s_flex_ali">
        <div class="width20 s_cfff height-120 fz-16 s_flex_center" style="background-color: #F59A23;">门店数据</div>
        <div class="width25 s_flex_center">
          <div>
            <p>签收商品数量
              <a-tooltip placement='right'>
                <template #title>
                  <p>统计当天出货单收货人是门店，且签收时间是今天的订单中包含的总小标数</p>
                </template>
                <InfoCircleOutlined class="fz-18 s_c376" />
              </a-tooltip>
            </p>
            <p class="fz-30 s_font_b">{{homeData.store_sign_for_product_num || 0}}</p>
          </div>
        </div>
        <div class="width25 s_flex_center">
          <div>
            <p>退货商品数量
              <a-tooltip placement='right'>
                <template #title>
                  <p>统计当天退货人是门店的退货单中包含的总小标数</p>
                </template>
                <InfoCircleOutlined class="fz-18 s_c376" />
              </a-tooltip>
            </p>
            <p class="fz-30 s_font_b">{{homeData.store_refund_warehousing_product_num || 0}}</p>
          </div>
        </div>
      </div>
    </a-card>
  </a-card>
</template>
<script>
  import { InfoCircleOutlined } from "@ant-design/icons-vue";
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { getHome } from "@/api/antiFleeing";
  import { iscode } from "@/utils/app";
  import { message } from "ant-design-vue";
  export default {
    components: { InfoCircleOutlined },
    setup() {
      const state = reactive({
        homeData:{},
      });
      const initData = async () => {
        let res = await getHome().then(res => res.data)
        if (iscode(res)) {
          state.homeData = res.data
        } else {
          message.error(res.msg);
        }
      }
      onMounted(() => {
        initData()
      });
      return {
        ...toRefs(state)
      };
    }
  };
</script>